export default __webpack_public_path__ + "static/media/flower-top.b14bf299.png";